module.exports = __webpack_public_path__ + "static/media/conference.cd2246ec.jpg";